import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, useLocation } from '@tanstack/react-router';
import { memo, type SyntheticEvent, useMemo } from 'react';
import { ACTIVE_PROPS, DESKTOP_BREAKPOINT, isNavPathActive } from './constants';
import { useFilteredNavItems } from './useFilteredNavItems.ts';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginLeft: 'calc(4 * var(--mui-spacing))',
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    alignItems: 'center',
    minHeight: 0,
  },
  // Match Tools / Rewards triggers (32px tall, padding 8px, lineHeight 1.25).
  '& .MuiTab-root': {
    minHeight: 32,
    padding: '8px',
    lineHeight: 1.25,
    transition: 'color 200ms',
  },
  '& .MuiTab-root:not(.Mui-selected):hover': {
    color: 'var(--mui-palette-text-primary)',
  },
  '& .MuiTabs-indicator': {
    bottom: 0,
  },
}));

export const NavigationTabs = memo(function NavigationTabs() {
  const location = useLocation();
  const filteredNavItems = useFilteredNavItems();
  // Overflow → Tools dropdown; rewardsMenu → Rewards hover menu. Neither belongs in the tab strip.
  const tabItems = useMemo(() => filteredNavItems.filter((item) => !item.overflow && !item.rewardsMenu), [filteredNavItems]);

  const tabValue = useMemo(() => {
    const matchingItem = tabItems.find((item) => isNavPathActive(item.path, location.pathname));
    return matchingItem ? matchingItem.value : false;
  }, [location.pathname, tabItems]);

  const handleTabChange = (_event: SyntheticEvent, _newValue: number) => {};

  return (
    <StyledTabs value={tabValue} onChange={handleTabChange} visibleScrollbar={false}>
      {tabItems.map((item) => (
        <Tab
          key={item.value}
          value={item.value}
          to={item.path}
          label={item.label}
          component={Link}
          activeProps={ACTIVE_PROPS}
        />
      ))}
    </StyledTabs>
  );
});
